export default {
    getAvailabilityRange: (num: number) => {
        switch (true) {
            case (num === 0):
                return '0';
            case (num < 4):
                return '1 to 3';
            case (num < 7):
                return '4 to 6';
            case (num < 11):
                return '7 to 10';
            case (num < 16):
                return '11 to 15';
            default:
                return '16 or more';
        }
    },

    getDaysOfWeek(days: string[]) {
        switch (true) {
            case days.length === 7:
                return 'all';
            case !days.includes('Fri') && !days.includes('Sat'):
                return 'Sun-Thu';
            case !days.includes('Sun')
                && !days.includes('Mon')
                && !days.includes('Tue')
                && !days.includes('Wed')
                && !days.includes('Thu'):
                return 'Fri-Sat';
            default:
                return 'mixed';
        }
    },

    getPriceRange: (num: number) => {
        const price = num / 100;
        if (price < 51) {
            return 'Up to 50';
        } else if (price < 75) {
            return '51 - 74';
        } else if (price <  100) {
            return '75 - 99';
        } else if (price < 150) {
            return '100 - 149';
        } else if (price < 200) {
            return '150 - 199';
        } else {
            return '200+';
        }
    },

    getPercentage: (oldVal: number, newVal: number) => {
        return Math.round((newVal - oldVal) / oldVal * 100);
    },

    getPercentageRange: (percentage: number) => {
        if (percentage < 26) {
            return '0% - 25%';
        } else if (percentage < 51) {
            return '26% - 50%';
        } else if (percentage < 76) {
            return '51% - 75%';
        } else {
            return '76% - 100%';
        }
    },
};
